<template>
  <!-- Navbar -->
  <nav id="topBar" class="absolute px-4 top-0 left-0 w-full z-9 bg-white  md:flex-row md:flex-no-wrap md:justify-start flex items-center p-2">
    <div class="relative flex flex-0 items-center w-full h-12 z-49">
      <!-- Brand -->

      <button @click="actionSidebar" class="focus:outline-none mat-focus-indicator mat-icon-button mat-button-base text-blue-600">
        <span class="mat-button-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path></svg></span
        ><span matripple="" class="mat-ripple mat-button-ripple mat-button-ripple-round"></span><span class="mat-button-focus-overlay"></span>
      </button>

      <router-link v-if="user && $f.getPermission(user,'dashboard')" to="/"  class="text-blue-600">
        <svg class="inline-block ml-2 text-blue-600 h-6  w-6 fill-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M3.889 3h6.222a.9.9 0 0 1 .889.91v8.18a.9.9 0 0 1-.889.91H3.89A.9.9 0 0 1 3 12.09V3.91A.9.9 0 0 1 3.889 3zM3.889 15h6.222c.491 0 .889.384.889.857v4.286c0 .473-.398.857-.889.857H3.89C3.398 21 3 20.616 3 20.143v-4.286c0-.473.398-.857.889-.857zM13.889 11h6.222a.9.9 0 0 1 .889.91v8.18a.9.9 0 0 1-.889.91H13.89a.9.9 0 0 1-.889-.91v-8.18a.9.9 0 0 1 .889-.91zM13.889 3h6.222c.491 0 .889.384.889.857v4.286c0 .473-.398.857-.889.857H13.89C13.398 9 13 8.616 13 8.143V3.857c0-.473.398-.857.889-.857z"></path></svg> <span class="text-blue-600">Dashboard</span>
      </router-link>

      <div class="flex items-center pl-2 ml-auto space-x-2">
        <!-- v-if="typeUser=='Seller'" -->
      <div class=" h-full text-black" v-if="typeUser=='Seller'">  <chatNotify :warehouse="idWharhouse" /> </div>
        <router-link v-if="typeUser=='Admin'" class=" h-full text-black router-link-exact-active router-link-active"  to="/livechat" >
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
          </svg>
        </router-link>
        <!-- <Formation :user="user" /> -->
        <Warhouses :user="user" @changeWrahouse="changeWrahouse" :warhouseSelected="warhouseSelected" :idWharhouse="idWharhouse" :sous_idWharhouse="sous_idWharhouse" :sous_warehouses="sous_warehouses" />
        <ul>
          <user-dropdown :user="user" />
        </ul>
      </div>
    </div>
  </nav>
  <!-- End Navbar -->
</template>

<script>
import chatNotify from '../components/livechat/ChatNotify.vue'
import UserDropdown from "@/components/Dropdowns/UserDropdown.vue";
import NotificationDropdown from "@/components/Dropdowns/NotificationDropdown.vue";
import Warhouses from "@//components/Dropdowns/Warhouses.vue";
import Formation from "@//components/Dropdowns/formation.vue";
export default {
  components: {
    UserDropdown,
    NotificationDropdown,
    Warhouses,
    Formation,
    chatNotify
  },
  props: {
    typeUser: { type: String },
    user: { type: Object },
    warhouseSelected: { type: String },
    idWharhouse: { type: Object },
    sous_idWharhouse: { type: String },
    sous_warehouses: { type: Array },
  },
  mounted() {
     
  },
  data() {
    return {
      topBar: "bg-white",
      dropdownPopoverShow: false,
    };
  },
  methods: {
    actionSidebar() {
      this.$store.dispatch("actionSidebar");
    },
    changeWrahouse: function(val) {
      this.$emit("changeWrahouse", val);
    },
  },
};
</script>
<style>
#topBar {
  background: white none repeat scroll 0% 0%;
  color: #fff;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
}
.z-9 {
  z-index: 9;
}
.drop-item {
  padding: 0.7rem 1.5rem;
  display: flex;
  align-items: center;
  width: 100%;
  clear: both;
  font-weight: 400;
  text-align: inherit;
  white-space: nowrap;
  background-color: initial;
  border: 0;
}
.dropdown-menu-shipp {
  inset: inherit !important;
  margin: inherit !important;
  transform: inherit !important;
  right: 0 !important;
  left: auto !important;
}
.media {
  display: flex;
  align-items: flex-start;
}
.user-details .media .avatar img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.align-self-start {
  align-self: flex-start !important;
}
.media-body {
  flex: 1;
}
.user-details .media .media-body .user-title {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.84);
  margin-bottom: 2px;
}
.user-details .media .media-body .user-subtitle {
  font-size: 13px;
  color: #232323;
  margin-bottom: 0;
}
.profile .title{
    float: left;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 75%;
}
.profile .details{
    font-size: 12px;
    opacity: 0.4;
    display: block;
    clear: both;
    text-transform: uppercase;
}
</style>
